
const VueRecaptcha = require('vue-recaptcha/dist/vue-recaptcha.min.js');
const axios = require('axios/dist/axios.min.js');

const grade = window.grade;
const activation_request_endpoint =
    grade.home_url + '/wp-json/gift-card/activate';

module.exports = {
    name: 'ActivationTool',
    el: '.activation-tool',

    components: { VueRecaptcha },

    data() {
        return {
            activationCode: null,
            referenceNumber: null,
            enterCard: true,
            cardActivated: false,
            isLoading: false,
            errors: [],
            validationError: false,
            recaptchaKey: grade.recaptcha_site_key
        };
    },

    computed: {},

    mounted() {
        this.isLoading = false;
    },

    methods: {
        submitActivationRequest() {
            this.enterCard = false;
            this.errors = [];
            this.isLoading = true;
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };

            const requestData = {
                activationCode: this.activationCode,
                referenceNumber: this.referenceNumber,
            };

            axios.post(activation_request_endpoint, requestData, config).then(res => {
                const statusCode = parseInt(res.data.statusCode) || 200;
                if (statusCode >= 500) {
                    // server error
                    this.errors = '<p class=\'error\'>Unfortunately we have been unable to activate your gift card order at this time, please contact giftcards@metcash.com</p>';
                } else if ( // card activated
                    res.data.GiftCardActivationResponse && res.data.GiftCardActivationResponse.Code === 1) {
                    this.cardActivated = true;
                } else if ( // if the card has already been activated
                    res.data.GiftCardActivationResponse && res.data.GiftCardActivationResponse.Code === 6) {
                    this.errors = `<p class='info'>It looks like your order is already activated. You can check the balance of your gift card(s) <a href='/check-balance/'>here</a></p>
									<p class='info'>If you are still experiencing issues, please contact giftcards@metcash.com</p>`;
                } else if ( // if the card has already been activated
                    res.data.GiftCardActivationResponse && res.data.GiftCardActivationResponse.Code === 2) {
                    this.errors = `<p class='error'>Unfortunately, we have been unable to activate your gift card order due to the information not matching our records. Please try again.</p>
									<p class='error'>If you are still experiencing issues, please contact giftcards@metcash.com</p>`;
                } else {
                    // other errors
                    this.errors = '<p class=\'error\'>Unfortunately we have been unable to activate your gift card order at this time, please contact giftcards@metcash.com</p>';
                }
            })
                .finally(() => {
                    this.isLoading = false;
                    var body = jQuery('html, body');
                    body.stop().animate({ scrollTop: 0 }, 500, 'swing', function () { });
                });
        },

        submit() {
            this.$refs.recaptcha.execute();
            this.isLoading = true;
        },

        success() {
            var body = jQuery('html, body');
            body.stop().animate({ scrollTop: 0 }, 500, 'swing', function () { });
        },

        fail() { },

        reset() { },

        onVerify(response) {
            this.errors = [];
            this.cardActivated = false;

            if (!this.activationCode) {
                this.validationError = true;
                this.errors = '<p class=\'error\'>Reference Number or Activation code is required.</p>';
            } else if (response) {
                this.validationError = false;
                this.submitActivationRequest();
            }

            this.$refs.recaptcha.reset();
        },

        onExpired() {
            this.$refs.recaptcha.reset();
        },
    },
};
